import React from 'react';

export const WhatsAppHeader = ({
  searchTerm,
  onSearchChange,
  filterButtonMessages,
  onFilterToggle,
  isLoading
}) => {
  return (
    <div className="bg-white shadow-sm border border-gray-200 mb-6">
      <div className="px-6 py-4">
        <div className="flex flex-col sm:flex-row sm:items-center gap-4">
          <div className="flex-1">
            <input
              type="text"
              value={searchTerm}
              onChange={onSearchChange}
              placeholder="Search messages..."
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
            />
          </div>
          <div className="flex items-center justify-center sm:justify-start space-x-2">
            <span className="text-sm text-gray-600 whitespace-nowrap">Hide Button Replies</span>
            <label className="relative inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                checked={filterButtonMessages}
                onChange={onFilterToggle}
                className="sr-only peer"
              />
              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-green-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-green-600"></div>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhatsAppHeader;
